angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-storage-factory',
        function ($api, $factory) {
            $api.factory.storage = $factory;
        },
    ])
    .factory('graph-storage-factory', [
        'graph-api-client',
        function (client) {
            function storages(entry, id) {
                if (entry === 'user') entry = undefined;

                this.query = function (options) {
                    return client.get([entry, id, 'attachment'], options);
                };

                this.upload = function (data, type, options) {
                    var _options = {};

                    angular.extend(_options, options);

                    if (type === 'documents' || type === 'videos') {
                        angular.extend(_options, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined },
                        });
                    }

                    return client.post([entry, id, type], data, _options);
                };
            }

            /**
             *  @type {String}
             */
            return {
                storages: function (entry, id) {
                    return new storages(entry, id);
                },
            };
        },
    ]);
